import React, { createContext, useContext } from "react";
import { getConfiguration } from "../data/utils";
import { useFetchNew } from "../data/fetch/useFetch";
import { parseWidgetData } from "../data/parseWidgetData";

export const WidgetsContext = createContext(null);

export function useWidgets() {
    return useContext(WidgetsContext);
}

export default function WidgetsProvider(props) {
    const conf = getConfiguration();
    const [, , data] = useFetchNew(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false)
    );

    return (
        <WidgetsContext.Provider value={data}>
            {props.children}
        </WidgetsContext.Provider>
    );
}
